export const PHONE_CODE_LENGTH = 3;
